// 1. 외부 패키지
import { Suspense } from "react";

// 2. 프로젝트 내부 alias


// 3. 상대 경로
import MobileGNB from "../layout/mobile-gnb";
import BasicMobileGnb from "./basic-mobile-gnb";

// 4. 타입

const BasicMobileGnbWrapper = () => {
	return (
		<Suspense fallback={ <MobileGNB title="" /> }>
			<BasicMobileGnb />
		</Suspense>
	);
};

export default BasicMobileGnbWrapper